import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { getPopulatedLayout, getStaticFormFields, setLayout, setPopulatedLayout, updateLayout } from "../../../core/actionCreators/lmsActionCreator"
import { toast } from "react-hot-toast"
import ParentComponent from "../../components/Component/ParentComponent"
import SideNavbar from "../../components/Navbar/SideNavbar"
import ComponentListHeader from "../../components/Header/ComponentListHeader"
import AddComponentPopup from "../../components/Popup/AddComponentPopup"
import CloneLayoutPopup from "../../components/Popup/CloneLayoutPopup"
import Loader from "../../components/Loader/Loader"
import "./LayoutPage.scss"
import JsonViewPopup from "../../components/Popup/JsonViewPopup"

const Layout = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams();
    const [layoutId, setLayoutId] = useState("")


    const [jsonViewPopup, setJsonViewPopup] = useState(false)
    const [addComponentPopup, setAddComponentPopup] = useState(false)
    const [cloneLayoutPopup, setCloneLayoutPopup] = useState(false)

    //Drag to reorder
    const [orderedComponents, setOrderedComponents] = useState<any[]>([])
    const [dragIndex, setDragIndex] = useState<number | null>(null)
    const [overIndex, setOverIndex] = useState<number | null>(null)
    let { populatedLayout, isLoading, layoutJson } = useSelector((s: any) => s.lmsStore);
    let { user } = useSelector((s: any) => s.authStore);


    const fetchPopulatedLayout = (_layoutId: any) => {
        let callback = (r: any) => {
            if (r && r.data && r.data.attributes && r.data.attributes.length == 0) {
                // navigate(`/layout/${_layoutId}/component`)
            }
        }
        dispatch(getPopulatedLayout(_layoutId, callback))
    }

    useEffect(() => {
        if (params.layoutId) {
            setLayoutId(params.layoutId)
            fetchPopulatedLayout(params.layoutId)
            dispatch(getStaticFormFields(null, null))
        }
        return () => {
            dispatch(setLayout({}))
            dispatch(setPopulatedLayout({}))
        }
    }, [params]);

    //Local copy so a drag can be shown before the save comes back
    useEffect(() => {
        setOrderedComponents(populatedLayout?.populatedComponents || [])
    }, [populatedLayout])

    const resetDragState = () => {
        setDragIndex(null)
        setOverIndex(null)
    }

    const dragStartHandler = (_index: number) => {
        setDragIndex(_index)
    }

    const dragOverHandler = (_e: any, _index: number) => {
        //Without this the drop event never fires
        _e.preventDefault()
        if (_index !== overIndex) setOverIndex(_index)
    }

    const dropHandler = (_targetIndex: number) => {
        if (dragIndex === null || dragIndex === _targetIndex) {
            resetDragState()
            return
        }
        const reordered = [...orderedComponents]
        const [moved] = reordered.splice(dragIndex, 1)
        reordered.splice(_targetIndex, 0, moved)
        setOrderedComponents(reordered)
        resetDragState()
        saveOrderHandler(reordered)
    }

    //populatedComponents carry the component, the order lives on the layout component rows
    const saveOrderHandler = (_reordered: any[]) => {
        const rows = populatedLayout?.components || []
        const rowByComponentId = new Map(rows.map((r: any) => [r.componentId, r]))

        const components = _reordered.map((c: any, index: number) => {
            const row: any = rowByComponentId.get(c?.parent?.component?.id)
            return row ? { ...row, "order": index + 1 } : null
        })

        //Never send a partial list, it would drop components from the layout
        if (components.some((c: any) => !c) || components.length !== rows.length) {
            toast.error("Could not reorder, please refresh and try again.")
            fetchPopulatedLayout(layoutId)
            return
        }

        const payload = {
            "layout": populatedLayout.cmsLayoutResponse,
            "attributes": populatedLayout.attributes || [],
            "components": components,
            "modifiedBy": user.id || -1
        }
        dispatch(updateLayout(payload, () => fetchPopulatedLayout(layoutId)))
    }


    return (<>

        {jsonViewPopup && <JsonViewPopup data={layoutJson} jsonViewPopup={jsonViewPopup} setJsonViewPopup={setJsonViewPopup} />}
        {addComponentPopup && <AddComponentPopup page={"LAYOUT"} layoutId={layoutId} setAddComponentPopup={setAddComponentPopup} />}
        {cloneLayoutPopup && <CloneLayoutPopup
            layoutId={layoutId}
            layoutName={populatedLayout?.cmsLayoutResponse?.layoutName}
            layoutCode={populatedLayout?.cmsLayoutResponse?.layoutCode}
            device={populatedLayout?.cmsLayoutResponse?.device}
            componentCount={populatedLayout?.populatedComponents?.length}
            setCloneLayoutPopup={setCloneLayoutPopup} />}
        <div className="flex mainWrapper w-full">
            <div className="sidenav-wrapper">
                <SideNavbar />
            </div>
            <div className="right-container">
                <div className="header-container">
                    <ComponentListHeader
                        setJsonViewPopup={setJsonViewPopup}
                        layoutId={layoutId}
                        setAddComponentPopup={setAddComponentPopup}
                        setCloneLayoutPopup={setCloneLayoutPopup}
                        layoutName={populatedLayout?.cmsLayoutResponse?.layoutName}
                        device={populatedLayout?.cmsLayoutResponse?.device}
                        componentCount={populatedLayout?.populatedComponents?.length}
                        layoutCode={populatedLayout?.cmsLayoutResponse?.layoutCode} />
                </div>

                {/* Only block on the first load, a reorder save should not hide the list */}
                {isLoading && !orderedComponents.length ? <Loader /> : <>
                    <div className="body-container pt-[15px] pb-[15px] bg-sky-50">
                        {orderedComponents.length ?
                            orderedComponents.map((c: any, index: number) =>
                                <ParentComponent
                                    key={c?.parent?.component?.id || index}
                                    data={c}
                                    user={user}
                                    layoutId={layoutId}
                                    layoutCode={populatedLayout?.cmsLayoutResponse?.layoutCode}
                                    callbackFn={fetchPopulatedLayout}
                                    page="LAYOUT"
                                    order={index + 1}
                                    isDragging={dragIndex === index}
                                    isDragOver={overIndex === index && dragIndex !== index}
                                    onDragStart={() => dragStartHandler(index)}
                                    onDragOver={(e: any) => dragOverHandler(e, index)}
                                    onDrop={() => dropHandler(index)}
                                    onDragEnd={resetDragState}
                                />
                            )
                            : populatedLayout?.cmsLayoutResponse ?
                                <div className="empty-components bg-white m-[15px] p-[30px] rounded-lg text-center">
                                    <p className="text-sm text-[#43425D] font-semibold">No components on this page yet.</p>
                                    <p className="text-xs text-[#959595] mt-[5px]">Use Add Component to create one, or Select / Copy Component to reuse an existing one.</p>
                                </div>
                                : null}
                    </div>
                </>}
            </div>
        </div>
    </>)

}

export default Layout